import axios from "axios";
import * as sys from "./index";
import { $_GET, getUdidSync } from '@/assets/js/commonH5'
import { cloneDeep } from "lodash";

axios.defaults.timeout = 20000;

// 添加请求拦截器
axios.interceptors.request.use(
  (config = {}) => {
    const originParams = config.params
    config.params = Object.assign({}, config.params, sys.cookie.getJSON('DD_client') || {})
    let para = cloneDeep(config.params)
    // 优先获取URL中的get参数
    para.union_id = para.unionid = $_GET.unionid || para.unionid || ''
    para.user_client = para.ct = $_GET.user_client || $_GET.ct || para.ct || para.user_client || 'touch'
    para.client_version = para.cv = $_GET.client_version || $_GET.cv || para.cv || para.client_version || '1.0'
    para.udid = $_GET.udid || para.udid || ''
    para.timestamp = $_GET.timestamp || para.timestamp || ''
    // 去除重复的参数，会在buildParams方法中加中统一加上
    if (para.union_id) {
      delete config.params.union_id
    }
    if (para.user_client) {
      delete config.params.user_client
      delete config.params.ct
    }
    if (para.udid) {
      delete config.params.udid
    }
    if (para.client_version) {
      delete config.params.client_version
      delete config.params.cv
    }
    if (para.timestamp) {
      delete config.params.timestamp
    }
    if (para.permanent_id) {
      delete config.params.permanent_id
    }
    if (para.ucid) {
      delete config.params.ucid
    }
    // 加密串
    const encodeStr = {
      android: 'MC0CAQACBQC5FhxRAgMBAAECBF94RXkCAwDlNwIDAM63AgMAp7kCAwC9hwICR5c=',
      iphone: 'SunVince',
      touch: 'aFxdf3sq', // mapi和mapi7鉴权加密串
      mina: 'pond757heag7qg39ew8fvq38g8943yt=',
      swan: 'pondwdfdf833dflkfvq38g8943yt=',
      huawei: 'iiwelvkldsonvpq09328hflsni022=',
      alipay: 'EKYKskRo]{D0e+,jt8JpxKZN2lA@dF%0',
      qqminiapp: 'pond698libu8kc93dkfjejf68g893mn=',
    }
    const touchGwEncodeStr = '3e2d576c871dabf304557cacef780b84' // 网关鉴权加密串
    // 获取url配置
    function getPath (url = '') {
      let res = {
        protocol: '',
        url: '',
        moduleName: '',
        controller: '',
        action: '',
      }
      // 格式化url，统一变成url/moduleName/control/action的形式
      if (url.indexOf('http://') === 0) {
        res.protocol = 'http://'
        url = url.replace('http://', '')
      } else if (url.indexOf('https://') === 0) {
        res.protocol = 'https://'
        url = url.replace('https://', '')
      } else if (url.indexOf('//') === 0) {
        res.protocol = window.location.protocol + '//'
        url = url.replace('//', '')
      } else {
        res.protocol = window.location.protocol + '//'
        url = process.env.VUE_APP_GATEWAY_API.replace(/^https?:/, '').replace(/^\/\//, '') + (url.indexOf('/') === 0 ? url.substr(1) : url)
      }
      let arr = []
      if (url.indexOf('/mapi/') >= 0) {
        res.moduleName = 'mapi'
        arr = url.split('/mapi/')
        res.url = arr[0]
        arr = arr[1].split('/')
        res.controller = ''
        res.action = arr[0]
      } else if (url.indexOf('/mapi7/') >= 0) {
        res.moduleName = 'mapi7'
        arr = url.split('/mapi7/')
        res.url = arr[0]
        arr = arr[1].split('/')
        res.controller = arr[0]
        res.action = arr[1]
      } else {
        arr = url.split('/')
        res.moduleName = arr[1]
        res.url = arr[0]
        res.controller = arr[2]
        res.action = arr[3]
      }
      return res
    }
    // 鉴权code
    let timeStamp = 0
    const urlPath = getPath(config.url)
    function encodeParams (moduleName = '', action = '') {
      if (!action) {
        return ''
      }
      timeStamp = para.timestamp || new Date().getTime()
      const encodeStr = {
        android: 'MC0CAQACBQC5FhxRAgMBAAECBF94RXkCAwDlNwIDAM63AgMAp7kCAwC9hwICR5c=',
        iphone: 'SunVince',
        touch: 'aFxdf3sq', // mapi和mapi7鉴权加密串
        mina: 'pond757heag7qg39ew8fvq38g8943yt=',
        swan: 'pondwdfdf833dflkfvq38g8943yt=',
        huawei: 'iiwelvkldsonvpq09328hflsni022=',
        alipay: 'EKYKskRo]{D0e+,jt8JpxKZN2lA@dF%0',
      }
      const touchGwEncodeStr = '3e2d576c871dabf304557cacef780b84' // 网关鉴权加密串
      const userClient = para.ct
      if (moduleName === 'mapi7') {
        return sys.md5([urlPath.controller, urlPath.action, timeStamp, userClient === 'touch' ? '' : encodeStr[userClient], para.udid].join(','))
      } else if (moduleName === 'mapi') {
        return sys.md5([urlPath.action, timeStamp, encodeStr[userClient], para.udid].join(','))
      } else {
        return sys.md5([urlPath.controller, urlPath.action, para.udid || getUdidSync(), timeStamp, userClient === 'touch' ? touchGwEncodeStr : encodeStr[userClient]].join(''))
      }
    }
    // 生成get参数
    // getParams为当post时会有特殊参数需要放到get参数中（对象），注意，不能与默认参数值相同！
    function buildParams (moduleName = '', action = '', getParams = {}) {
      // 获取页面URL中的参数并截取重要参数
      let {
        permanent_id: permanentId = '',
        udid = '',
        union_id: unionId = '',
        ucid = '',
        user_client = 'touch',
        client_version = '1.0',
      } = para

      // 获取参数中的udid及permanentId
      if (getParams.udid) {
        udid = getParams.udid
        delete getParams.udid
      }
      if (getParams.permanentId) {
        permanentId = getParams.permanentId
        delete getParams.permanentId
      }

      if (getParams.unionId) {
        unionId = getParams.unionId
        delete getParams.unionId
      }
      const timeCode = encodeParams(moduleName !== 'mapi' ? 'mapi7' : 'mapi', action) // 默认使用mapi7生成time_code
      const tc = encodeParams('', action) // 网关鉴权参数
      if (getParams.ucid) {
        ucid = getParams.ucid
        delete getParams.ucid
      }
      let params = `?permanent_id=${permanentId}&udid=${udid}&timestamp=${timeStamp}&union_id=${encodeURIComponent(unionId)}&unionId=${encodeURIComponent(unionId)}&ts=${timeStamp}&user_client=${user_client}&client_version=${client_version}&ct=${user_client}&cv=${client_version}`
      // 增加tc和time_code
      params += `&time_code=${timeCode}&tc=${tc}`
      // mapi7会有a和c
      if (moduleName === 'mapi7') {
        const p = splitMapi7Params(action)
        params += `&a=${p.action}&c=${p.controller}`
      } else if (moduleName === 'mapi') {
        params += `&action=${action}`
      }
      if (ucid) params += `&ucid=${ucid}` // 加传ucid
      return params
    }
    // 生成调用url
    function baseUrl (moduleName = '', controller = '', action = '', getParams = {}) {
      if (!moduleName) return ''
      let url = ''
      if (moduleName === 'mapi7' || moduleName === 'mapi') {
        url = `/${moduleName}/mina/index.php`
      } else {
        // 默认网关
        url = config.url
      }
      return urlPath.protocol + urlPath.url + url + buildParams(moduleName, action, getParams)
    }
    config.url = baseUrl(urlPath.moduleName, urlPath.controller, urlPath.action, originParams || {})
    return config;
  },
  error => {
    // 请求错误处理
    return Promise.reject(error);
  }
);


// 在 response 拦截器实现
axios.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    console.log('axios,拦截器，error', error)
    return {}; //Promise.reject(error);
  }
);

export default axios;
